(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolong-game/assets/javascripts/components/days-selection.js') >= 0) return;  svs.modules.push('/components/numbergames/prolong-game/assets/javascripts/components/days-selection.js');

'use strict';

const {
  useContext
} = React;
const {
  CheckboxGroup,
  Checkbox
} = svs.ui.reactForm;
const {
  getBrandingClass,
  getProductId
} = svs.numbergames.productMapping;
const {
  drawDayLabels
} = svs.numbergames.draws.drawsUtils;
const {
  ProlongContext
} = svs.numbergames.prolong_game.context;
const getSelectableDays = (product, drawCount) => Object.entries(drawDayLabels(getProductId(product), {
  drawCount
})).map(_ref => {
  let [value, label] = _ref;
  return {
    value,
    label
  };
});
const DaysSelection = () => {
  const {
    selectedDays,
    setSelectedDays,
    drawCount,
    wager: {
      productName
    }
  } = useContext(ProlongContext);
  const selectableDays = getSelectableDays(productName, drawCount);
  const branding = getBrandingClass(productName);
  const handleCheckboxChange = e => {
    if (e.target.checked) {
      setSelectedDays(days => [...days, e.target.value]);
    } else {
      setSelectedDays(days => days.filter(day => day !== e.target.value));
    }
  };
  if (selectableDays.length < 2) {
    return null;
  }
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "padding-bottom"
  }, "Speldagar"), React.createElement("div", {
    className: "days-picker padding-bottom"
  }, selectableDays.map(_ref2 => {
    let {
      value,
      label
    } = _ref2;
    return React.createElement(CheckboxGroup, {
      key: value,
      className: "days-picker-item"
    }, React.createElement(Checkbox, {
      branding: branding,
      checked: selectedDays.includes(value),
      onChange: handleCheckboxChange,
      value: value
    }, React.createElement("span", {
      className: "f-capitalize"
    }, label)));
  })));
};
setGlobal('svs.numbergames.prolong_game.components.DaysSelection', DaysSelection);

 })(window);